import React from 'react';

function TasksPage() {
  return <div className="page-container"><h1>Tasks</h1><p>Tasks view coming soon...</p></div>;
}

export default TasksPage;
